import type { ChartFilter } from '../controls/ChartFilters/ChartFilters';

export type TokenPeriod = 'day' | 'week' | 'month' | 'year' | 'all';

type PeriodConfigItem = {
  value: TokenPeriod;
  label: string;
};

export const PeriodConfig: Record<TokenPeriod, PeriodConfigItem> = {
  day: {
    value: 'day',
    label: '1D',
  },
  week: {
    value: 'week',
    label: '7D',
  },
  month: {
    value: 'month',
    label: '1M',
  },
  year: {
    value: 'year',
    label: '1Y',
  },
  all: {
    value: 'all',
    label: 'All',
  },
};

export const defaultFilters: ChartFilter<TokenPeriod>[] = Object.values(
  PeriodConfig,
) as ChartFilter<TokenPeriod>[];

export const getPeriodFormat = (period: TokenPeriod, timestamp: string) => {
  const date = new Date(timestamp);

  const isMidnight = date.getHours() === 0 && date.getMinutes() === 0;

  if (period === 'day') {
    return isMidnight ? 'dd MMM' : 'hh:mm a';
  }

  if (['week', 'month', 'year'].includes(period)) {
    return 'dd MMM';
  }

  return 'dd MMM yyyy';
};
